export default "__VITE_ASSET__FDpruMke__"